import { useEffect, useState } from 'react';

const MOBILE_MAX = 640;

export function useViewport() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window === 'undefined' ? false : window.innerWidth < MOBILE_MAX,
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_MAX);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return { isMobile, isDesktop: !isMobile };
}
